import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import login from '../assets/img/login.webp';
import logo from '../assets/img/logo.jpg';
import '../assets/css/login.css';
import { BASE_URL } from '../BaseUrl/Baseurl';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [validationErrors, setValidationErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const forgotHandler = async (e) => {
        e.preventDefault();

        let formValidationErrors = {};
        if (!email) {
            formValidationErrors.email = "Email is required";
        }

        if (Object.keys(formValidationErrors).length !== 0) {
            setValidationErrors(formValidationErrors);
            return;
        }
       
        setIsLoading(true);

        try {
            const response = await axios.post(`${BASE_URL}forgot-password??type=live`, { email }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
            });

            console.log("Forgot Password Response:", response);

            if (response.data.status === "RC200") {
                toast.success("We have emailed your password reset link!");
                setEmail("");
            } else {
                toast.error("Invalid email, please try again.");
            }
        } catch (error) {
            console.log(error.response?.data?.message || "Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
           
        }
    };

    return (
        <div>
            {/* Toast Container */}
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                progressStyle={{ background: "green" }}
            />
            <section className="container-fluid">
                <div className="row">

                    {/* Left Side - Image */}
                    {/* <div className="col-lg-6 col-md-6 col-sm-12 col-12 m-0 p-0 d-lg-block d-md-block d-sm-none d-none">
                        <img src={login} alt="login-img" className="img-fluid login_img" />
                    </div> */}

                    {/* Right Side - Centered Content */}
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 d-flex align-items-center justify-content-center position-relative">
                        <div className="w-50">
                            <img src={logo} alt="logo" className="img-fluid mx-auto d-block mb-3" />
                            <h3 className='signin mt-4'>Forgot Your Password?</h3>
                            <p className='text-center signin_text p-0 m-0'>Reset Password with ByKit.</p>

                            <form className="w-100 mt-4 flex-grow-1 d-flex flex-column" onSubmit={forgotHandler}>
                                <div className='mt-3'>
                                    <label className="form-label signin_label">Email Address</label>
                                    <input
                                        name='email'
                                        type="email"
                                        className="form-control py-2 signin_input"
                                        value={email}
                                        placeholder="Enter Your Email"
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    {validationErrors.email && (
                                        <small className="text-danger">{validationErrors.email}</small>
                                    )}
                                </div>

                                <div className='mt-4'>
                                    <button
                                        type="submit"
                                        disabled={isLoading}
                                        style={{
                                            width: "100%",
                                            padding: "10px",
                                            fontSize: "16px",
                                            borderRadius: "5px",
                                            border: "none",
                                            backgroundColor: "#343a40",
                                            color: "white",
                                            cursor: isLoading ? "not-allowed" : "pointer",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "10px"
                                        }}
                                    >
                                        {isLoading ? (
                                            <>
                                                <svg
                                                    style={{ width: "20px", height: "20px", animation: "spin 1s linear infinite", color: "white" }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path
                                                        fill="currentColor"
                                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    ></path>
                                                </svg>
                                                Loading...
                                            </>
                                        ) : (
                                            "Send Recovery Email"
                                        )}
                                    </button>
                                </div>

                        
                                <Link className='text-decoration-none' to='/'>
                                    <p className='back_login mt-4'>Back to Login</p>
                                </Link>

                                <div className="auth-footer">&copy; {new Date().getFullYear()} ByKit, All rights reserved.</div>
                            </form>  
                        </div>
                    </div>

                </div>
            </section>
        </div>
    );
}

export default ForgotPassword;
